import React from 'react'
import {NavLink} from 'react-router-dom';

const NavBar = () => {
    return (
        <nav className="site-main-menu">
            <ul>
                <li className='mx-5'>
                    <NavLink to={process.env.PUBLIC_URL + "/"}><span className="menu-text text-dark">Home</span></NavLink>
                    
                </li>
                <li className='mx-5'>
                    <NavLink to={process.env.PUBLIC_URL + "/about"}><span className="menu-text text-dark">About Us</span></NavLink>
                 
                </li>
                <li className="has-children mx-5">
                    <NavLink to={process.env.PUBLIC_URL + ""}><span className="menu-text text-dark">Solutions</span></NavLink>
                    <span className="menu-toggle"><i className="far fa-angle-down"></i></span>
                    <ul className="sub-menu">
                        <li><NavLink to={process.env.PUBLIC_URL + "/ABMPlatforms"}><span className="menu-text text-dark">ABM Platforms</span></NavLink></li>
                       <hr></hr>
                        <li><NavLink to={process.env.PUBLIC_URL + "/Marketplaces"}><span className="menu-text text-dark">Marketplaces</span></NavLink></li>
                       <hr></hr>
                        <li><NavLink to={process.env.PUBLIC_URL + "/AccountManager"}><span className="menu-text text-dark">Account Manager/ <br></br> Customer Success Managers</span></NavLink></li>
                        <hr></hr>
                        <li><NavLink to={process.env.PUBLIC_URL + "/Publishers"}><span className="menu-text text-dark">Publishers</span></NavLink></li>
                        <hr></hr>
                        <li><NavLink to={process.env.PUBLIC_URL + "/PartnerManagers"}><span className="menu-text text-dark">Partner Managers</span></NavLink></li>
                    </ul>
                </li>
                 <li className='mx-5'>
                    <NavLink to={process.env.PUBLIC_URL + "/service"}><span className="menu-text text-dark">Services</span></NavLink>
                </li>
                <li className='mx-5'>
                    <NavLink to={process.env.PUBLIC_URL + "/resources"}><span className="menu-text text-dark">Resources</span></NavLink>
                </li>
                <li className='mx-5'>
                    <NavLink to={process.env.PUBLIC_URL + "/work"}><span className="menu-text text-dark">Blog</span></NavLink>
                </li>
                  <li className='mx-5'>
                    <NavLink to={process.env.PUBLIC_URL + "/contact"}><span className="menu-text text-dark">Contact Us</span></NavLink>
                </li>
            </ul>
        </nav>
    )
}

export default NavBar
